import { required, required_if, email, min, max, regex, confirmed, digits, min_value, alpha, alpha_num, numeric } from "vee-validate/dist/rules"
import { extend, localize } from "vee-validate"

extend("required", {
	...required,
	message: "Dieses Feld darf nicht leer sein."
})

extend('digits', digits)

extend('alpha', alpha)
extend('alpha_num', alpha_num)
extend('numeric', numeric)

extend("regex", {
	...regex,
	message: "Bitte ein gültiges Format eingeben."
})

extend("max", {
	...max,
	message: "Dieses Feld darf maximal {length} Zeichen lang sein."
})

extend("min", {
	...min,
	message: "Dieses Feld muss mindestens {length} Zeichen lang sein.",
})

extend("min_value", {
	...min_value,
	message: "Dieses Feld muss grösser als {value} sein.",
})

extend("email", {
	...email,
	message: "Bitte eine gültige E-Mail Adresse eingeben."
})

extend('phone', {
	message(fieldName) {
		// return `${fieldName} is not a valid phone number`;
		return 'Bitte eine gültige Telefonnummer eingeben.';
	},
	validate(value) {
		return new Promise(resolve => {
			resolve({ valid: /^(?:\+){0,2}\s*(?:\(?[0-9]\)?\s*){10,14}$/.test(value) })
		});
	}
})

extend('required_if_notchecked', {
	...required_if,
	validate(value, {target, values}) {
		if (target == false) {
			return value != ""
		}
		return true
	}
})

extend('confirmed', {
	...confirmed,
	message: "Bitte den selben Wert eingeben"
})

//currently simple implementation
//TODO: this validation should also happen and align in backend
extend('complexpw', {
	validate(value) {
		if (typeof value != "string") return false

		return /[0-9]/.test(value)  //one number
			&& /[a-z]/.test(value)  //one small letter
			&& /[A-Z]/.test(value)  //one big letter
			&& value.length >= 8
	},
	message: "Mindestens 8 Zeichen, Gross- Kleinbuchstaben und Zahlen"
})

export function setI18l(lang, data) {
	localize({
		[lang]: data
	})
	localize(lang)
}
